import { SEND_REFERRAL_EVENT_MESSAGE } from "../../../mutations/referrals";
import { useMutation } from "@apollo/client";
import { useDispatch } from "react-redux";
import { enqueueSnackbar } from "../../../state/ducks/notifiers";

const useSendReferralEventMessage = () => {
  const dispatch = useDispatch();
  const [sendReferralEventMessage] = useMutation(SEND_REFERRAL_EVENT_MESSAGE, {
    onError: () => {
      dispatch(
        enqueueSnackbar({
          message: `Failed while sending the referral event message`,
          options: { variant: "error" },
        })
      );
    },
  });

  return { sendReferralEventMessage };
};

export default useSendReferralEventMessage;
